import axios from 'axios'
import config from '../../../../config.json'
export default {
    async getUltimosSms({commit, getters}, search) {
        let {data} = await getters.getApi.get("message", { params: search })
        
        if (data.status) {
            commit('SET_ULTIMAS_MENSAGENS', data.data)
            return true
        } else {
            if(!search.isPagination)
                commit('SET_ULTIMAS_MENSAGENS', data.data || [])
            
            return false
        }
    },

    async setUltimosAgendamentos({commit, getters}, search) {
        let {data} = await getters.getApi.get("scheduling", { params: search })
        commit('SET_ULTIMOS_AGENDAMENTOS', data.data)
        if (data.data.length > 0) {
            return true
        } else {
            return false
        }
    },

    async loadResumo ({commit, getters}, search = {}) {
        let {data} = await getters.getApi.get("message/resumo", { params: search })
        return data
    },

    async sendSms ({commit, getters}, {sms, user_id=null}) {
        if(getters.getUser.nome == 'root')
        {
            let api_root = axios.create({
                baseURL: config.api_base
            })

            api_root.interceptors.request.use(config => {
                config.headers.common['Authorization'] = user_id

                return config
              }, err => {
                return Promise.reject(err)
            })


            let {data} = await api_root.post("message", sms)

            return data

        }

        else
        {
            let {data} = await getters.getApi.post("message", sms)
            return data
        }

    },

    async arquivos_saveArquivo ({commit, getters}, formData) {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let { data } = await getters.getApi.post("message/file", formData, config)
        return data
    },

    async arquivos_updateStatusArquivo ({getters}, mailing) {
        console.log(mailing)
        let { data } = await getters.getApi.put('templateMailing', mailing)
        return data
    },

    async arquivos_saveArquivoTemplateCampanha ({commit, getters}, formData) {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let { data } = await getters.getApi.post("templateMailing", formData, config)
        return data
    },

    async arquivos_getArquivoTemplateCampanha ({commit, getters}, search = {}) {
        let { data } = await getters.getApi.get("templateMailing", { params: search })

        commit('SET_TEMPLATES_CAMPANHA', data.data || [])
        return data
    },

    async arquivos_getAgendamentos ({commit, getters}, mes) {
        let { data } = await getters.getApi.get(`scheduling/month/`, { params: {mes: mes } })
        commit('SET_AGENDAMENTOS', data.data)
        return data
    },

    async arquivos_sendCampanha ({commit, getters}, formData) {
        let { data } = await getters.getApi.post("message/agendamento", formData)
        return data
    },

    async arquivos_cancelaCampanha ({commit, getters}, id) {
        let { data } = await getters.getApi.post("scheduling/cancelar", {_id: id})
        return data
    },

    async arquivos_alteraCampanha ({commit, getters}, {date, _id}) {
        let { data } = await getters.getApi.put("scheduling", {_id: _id, date: date})
        return data
    },

    async arquivos_getReenvios ({commit, getters}, _id) {
        let { data } = await getters.getApi.get(`message/getSchedulingFailed/`, { params: {scheduling_id: _id } })
        commit('SET_MENSAGENS_ERRO', data.data)
        return data
    },

    async arquivos_sendReenvios ({commit, getters}, reenvios) {
        let { data } = await getters.getApi.post("message/sendReenvio", reenvios)
        return data
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/mensagens/actions.js